import { createSlice } from "@reduxjs/toolkit";

const addModalCardsSlice = createSlice({
  name: "addModalCards",
  initialState: {
    isOpen: false,
    error: null,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
});

export const { openModal, closeModal } = addModalCardsSlice.actions;
export default addModalCardsSlice.reducer;
